import { render, staticRenderFns } from "./WithdrawHotel.vue?vue&type=template&id=72047204&scoped=true"
import script from "./WithdrawHotel.vue?vue&type=script&lang=js"
export * from "./WithdrawHotel.vue?vue&type=script&lang=js"
import style0 from "./WithdrawHotel.vue?vue&type=style&index=0&id=72047204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72047204",
  null
  
)

export default component.exports